import React from 'react'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'

import { translate } from 'react-i18next';

import PreOrderBlock from './PreOrderBlock.jsx';
// import PreOrderBlockSmallBusiness from './PreOrderBlockSmallBusiness.jsx';
import ProductsGroupLong from './ProductsGroupLong.jsx';


var ProductsLong = React.createClass({


  getInitialState() {
    return {store: AvailabilityStore.getState()};
  },

  componentDidMount() {
    AvailabilityStore.listen(this.onChange);
  },

  componentWillUnmount() {
    AvailabilityStore.unlisten(this.onChange);
  },

  onChange(state) {
    this.setState({store: state});
  },


  showVoiceOnly() {
  	AvailabilityActions.showVoiceOnly();
  },

	render() {
   		const { t } = this.props;
   		var store = this.state.store;

		var products = store.get('products').toJS();

		var titlekey = "common:choose_speed";

		var voice_only, voice_only_toggle = null;

		var show_voice_only = store.get('show_voice_only');
		var voice_only_available = store.get('voice_only_available');

		for(var key in products) {
			if(typeof products[key] == 'function') {
				continue;
			}
			if(products[key].product_key.indexOf('voice_only') !== -1 && !show_voice_only) {
				voice_only = products.splice(key, 1)[0];
			}
		}

		if(store.get('fiber_available') || store.get('fiber_xgspon_available')) {
			if(store.getIn(['fiber_product', 'product_key']).indexOf('preorder') !== -1) {
				titlekey = "";
			}
		}
		else if(products.length == 1) {
			titlekey = "common:one_service_option";
		}

        var product_groups = [];
        // let preorder_block = '';
        let is_preorder_available = false;
        let is_business = false;

        if((store.get('fiber_available') || store.get('fiber_xgspon_available'))
            && store.getIn(['fiber_product', 'product_key']).indexOf('preorder') !== -1
        ) {
            if(store.getIn(['fiber_product', 'product_key']).indexOf('business') !== -1) {
                // preorder_block = <PreOrderBlockSmallBusiness />;
                is_business = true;
                product_groups.push({
                    title: "Available for Pre-Order",
                    needNow: false,
                    products: products.filter(function(p) {
                        return p.product_key.indexOf('preorder') !== -1;
                    })
                });

            }

            is_preorder_available = true;

            product_groups.push({
                title: "Available Now",
                needNow: is_business && is_preorder_available ? true : false,
                products: products.filter(function(p) {
                    return p.product_key.indexOf('preorder') === -1;
                })
            });
        } else {
            product_groups = [{
                products: products
            }];
        }

        if(voice_only_available && !show_voice_only
            && (!store.get('fiber_available') && !store.get('fiber_xgspon_available'))
            ) { // Voice is available and NOT fiber (we don't want to directly offer phone for DSL)
            voice_only_toggle = <div className="snc-bun-follower text-center"><a className="snc-alt-link" onClick={this.showVoiceOnly}>{t("common:voice_only_available")}</a></div>;
      	}

        /*
            reduce all promos from all products
            if there's only 1, display it as promo block
         */
        var common_promo_block = '';
        var common_promos = products.reduce(function(carry, product) {
            if(product.promo && product.promo.code) {
                carry[product.promo.code] = 1;
            } else {
                carry['nopromo'] = 1;
            }
            return carry;
        }, {});
        if(Object.keys(common_promos).length == 1 && products[0] && products[0].html) {
            common_promo_block = (<div dangerouslySetInnerHTML={{__html: products[0].promo.html}}></div>);
        }

        let has_ipbb = products.filter(function(p) {
           return p.product_key.indexOf('ipbb') !== -1;
        }).length;

        let show_ipbb_warning = false; // Force to false to remove message. Preserving old code incase this gets reenstated.

        const ipbb_warning = (
            <div className={"container"}>
                <div className={"row"}>
                    <div className={"col-12"}>
                <div style={{backgroundColor: '#27AAE1', padding: '20px 40px', margin: '5px 0px 20px 0px', color: '#fff'}}>
                    <p>
                    {t('ipbb_warning')}
                    </p>
                    </div>
                    </div>
                </div>
            </div>
        );

		return (
			<div>
				{/* {preorder_block} */}
                {common_promo_block}
                {( show_ipbb_warning ? ipbb_warning : false )}
				<div className="container" >
					<div key="Products">
							{product_groups.map(function(group, index){
								return <ProductsGroupLong
									key={index}
                                    title={(group.title ? group.title : '')}
									products={group.products}
                                    show_voice_only={show_voice_only}
                                    is_preorder_available={is_preorder_available}
                                    otherProducts={group.needNow ? true : false}
								/>;
				            })}
						{voice_only_toggle}
					</div>
				</div>
			</div>
		);

	}
});

export default  translate('common', { wait: true })(ProductsLong);
